import React from 'react';
import Collapse from 'react-collapse';
import FilterItemContainer from './itemContainer';
import FilterItemHeading from './itemHeading';
import FilterItemToggle from './itemToggle';
import FilterItemOptions from './itemOptions';

class SearchFilterItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: true };
  }

  toggle() {
    this.setState(state => ({ expanded: !state.expanded }));
  }

  render() {
    const { icon, title, options, location, onSelect } = this.props;
    const { expanded } = this.state;

    return (
      <FilterItemContainer icon={icon}>
        <FilterItemHeading onClick={() => this.toggle()} title={title}>
          <FilterItemToggle>{expanded ? 'Hide' : 'Show'}</FilterItemToggle>
        </FilterItemHeading>
        <Collapse isOpened={expanded}>
          <FilterItemOptions
            options={options}
            location={location}
            onSelect={onSelect}
          />
        </Collapse>
      </FilterItemContainer>
    );
  }
}

export default SearchFilterItem;
